var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`wallet-workpackage-status ${_vm.color} ${_vm.color.includes('lighten') || _vm.color.includes('darken')? '':'lighten-1'}`,style:(`
  ${_vm.justify_content?`justify-content: ${_vm.justify_content};`:''}
  ${_vm.textcolor?`color: ${_vm.textcolor};`:'color: black;'}
  `)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }